import {BaseAPIManager} from "./BaseAPIManager";
import ApiConstants from "./ApiConstants";
import TemplateSettingsManager from "../Manager/TemplateSettingsManager";
import { getCapitalized, getIsPayrollCheck, getIsPayslip, getIsWorkOrder } from "../Utilities/Utility";

export class TemplateRepository extends BaseAPIManager {

    uploadTemplateScreenShot(screenShotData, success, failure) {
        this.uploadAttachment(screenShotData, (response) => success(response), (error) => failure(error))
    }

    saveTemplateSettings(templateType, templateName, relativeImagePath, success, failure) {
        let urlString = ApiConstants.URL.BASE + ApiConstants.URL.TEMPLATE_SETTINGS
        let app = 'ERP'

        if(getIsPayslip(templateType) || getIsPayrollCheck(templateType)) {
            app = 'PEOPLE'
        }
        else if(getIsWorkOrder(templateType)) {
            app = 'MRP'
        }
        let data = {
            appName: app,
            description: "Saved Template" + app + '-' + templateType,
            templateData: JSON.stringify(TemplateSettingsManager.defaultTemplateSettings),
            templateName: templateName,
            type: templateType.toUpperCase(),
            pageFormat: this.getPaperFormatForSave(),
            defaultTemplate: TemplateSettingsManager.getIsDefaultTemplate(),
        }
        this.post(urlString, data,
            (response) =>  {
                // console.log('This is a response *******' + JSON.stringify(response))
                success(response)
            },
            (error) =>  {
                alert(JSON.stringify(error))
                failure(error)
            }

        )
    }

    fetchTemplateSettings(type, success, failure) {
        var subUrl = ApiConstants.URL.GET_ERP_TEMPLATE_SETTINGS + type
        if(getIsPayslip(type.toLowerCase()) || getIsPayrollCheck(type.toLowerCase())) {
            subUrl = ApiConstants.URL.GET_PEOPLE_TEMPLATE_SETTINGS + type
        }
        else if (getIsWorkOrder(type.toLowerCase())) {
            subUrl = ApiConstants.URL.GET_MRP_TEMPLATE_SETTINGS + type
        }

        let urlString = ApiConstants.URL.BASE + subUrl
        this.get(urlString,(response) => success(response), (error) => failure(error))
    }

    updateTemplateSettings(templateType, templateID, templateName, relativeImagePath, success, failure) {
        let urlString = ApiConstants.URL.BASE + ApiConstants.URL.TEMPLATE_SETTINGS + '/' + templateID
        let app = 'ERP'

        if (getIsPayslip(templateType) || getIsPayrollCheck(templateType)) {
            app = 'PEOPLE'
        }
        else if (getIsWorkOrder(templateType)) {
            app = 'MRP'
        }
        let data = {
            appName: app,
            description: "Saved Template" + app + '-' + templateType,
            templateData: JSON.stringify(TemplateSettingsManager.defaultTemplateSettings),
            templateName: templateName,
            type: templateType.toUpperCase(),
            pageFormat: this.getPaperFormatForSave(),
            defaultTemplate: TemplateSettingsManager.getIsDefaultTemplate(),
        }
        this.put(urlString, data,
            (response) =>  {
                // console.log('This is a response *******' + JSON.stringify(response))
                success(response)
            },
            (error) => failure(error)
        )
    }

    deleteTemplateSettings(templateID, success, failure) {
        let urlString = ApiConstants.URL.BASE + ApiConstants.URL.TEMPLATE_SETTINGS + '/' + templateID
        this.delete(urlString,
            (response) => {
                success(response)
            },
            (error) => failure(error)
        )
    }

    getPaperFormatForSave() {
        if (TemplateSettingsManager.getPageFormat() !== undefined &&
            TemplateSettingsManager.getPageFormat() !== null) {
            if (TemplateSettingsManager.getPageFormat() === 'four_six' || TemplateSettingsManager.getPageFormat() === 'three_five' ) {
                return TemplateSettingsManager.getPageFormat()
            }
        }

        return getCapitalized(TemplateSettingsManager.getPageFormat())
    }
}
